import CustomButton from 'Components/CustomButton'
import { LOGIN_PAGE_PATH } from 'Util/constants'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Card, Typography } from '@mui/material'
import Cookies from 'js-cookie'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { t } from 'ttag'

interface LoginCardProps {
  title: string
  image: string
}

function LoginCard({ title, image }: Readonly<LoginCardProps>) {
  const location = useLocation()
  const authenticationUrl = `${import.meta.env.VITE_AUTH_BASE_URL}/api/oidc/authenticate/`

  const { pathname: redirectUrl } = location.state?.referrer || { pathname: LOGIN_PAGE_PATH }

  function onClick() {
    if (redirectUrl !== '/' && redirectUrl !== LOGIN_PAGE_PATH) {
      Cookies.set('redirectUrl', redirectUrl)
    }
    globalThis.location.href = authenticationUrl
  }

  return (
    <Card
      sx={{
        p: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '300px'
      }}
    >
      <LogoImg alt={`${title} logo`} src={image} />
      <Typography component="h2" variant="subtitle1" sx={{ fontSize: '15px', mb: 4, mt: 4 }}>
        {t`Login with ${title}`}
      </Typography>
      <CustomButton onClick={onClick} sx={{ textDecoration: 'none' }}>
        {t`Go to login`}
        <ArrowForwardIcon sx={{ ml: 1 }} />
      </CustomButton>
    </Card>
  )
}

const LogoImg = styled.img`
  height: 60px;
`

export default LoginCard
